var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"operation-errors"},[_c('div',{staticClass:"action-header"},[_vm._v(_vm._s(_vm.action))]),_c('ol',{staticClass:"messages"},_vm._l((_vm.errorMessages),function(errorMessage,index){return _c('li',{key:index},[_vm._v(" "+_vm._s(errorMessage)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }